export enum EnumModulo {
    KDS = 1,
    EntregaLocal = 2,
    EntregaDelivery = 3,
    Motoboy = 4,
}